import {useSelector} from "react-redux";
import {portfolioSelecror} from "../../Selectors";
import {PortfolioItem} from "../Portfolio/PortfolioItem";
import React, {useEffect, useRef, useState} from "react";
import * as THREE from 'three';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls'


export const Home = React.memo(() => {

    const model = useRef<any>(null)
    const introTitle = useRef<any>(null)
    const btn = useRef<any>(null)

    const [viewMode, setViewMode] = useState(false)

    useEffect(() => {

        const scene = new THREE.Scene()
        const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight)
        camera.position.z = 10
        camera.position.y = 10


        const renderer = new THREE.WebGLRenderer({alpha: true, antialias: true})
        renderer.setClearColor(0x000000, 0)
        renderer.setSize(1920, 1080)
        renderer.domElement.setAttribute('id', 'model')
        if (model.current.children.length < 1) {
            model.current.appendChild(renderer.domElement)
        }

        const controls = new OrbitControls(camera, renderer.domElement);

        controls.enableZoom = false
        controls.enabled = false
        controls.enableDamping = true
        controls.enablePan = true


        btn.current.addEventListener('click', () => {
            controls.enabled = !controls.enabled
            console.log(camera.position)
            if (!controls.enabled) {
                controls.reset()
            }
        })

        const aLigth = new THREE.AmbientLight(0x404040, 1.2)
        scene.add(aLigth)

        const pLigth = new THREE.PointLight(0xFFFFFF, 1.2)
        pLigth.position.set(0, 10, 20)
        scene.add(pLigth)

        window.addEventListener('resize', onWindowResize, false);

        function onWindowResize() {

            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();

            renderer.setSize(window.innerWidth, window.innerHeight);

        }

        function resizeRendererToDisplaySize(renderer:any) {
            const canvas = renderer.domElement;
            const width = canvas.clientWidth;
            const height = canvas.clientHeight;
            const needResize = canvas.width !== width || canvas.height !== height;
            if (needResize) {
                renderer.setSize(width, height, false);
            }
            return needResize;
        }

        function render(time:any) {
            time *= 0.001;

            if (resizeRendererToDisplaySize(renderer)) {
                const canvas = renderer.domElement;
                camera.aspect = canvas.clientWidth / canvas.clientHeight;
                camera.updateProjectionMatrix();
            }

            renderer.render(scene, camera);

            requestAnimationFrame(render);
        }

        requestAnimationFrame(render);

        const loader = new GLTFLoader()
        let obj: any = null

        loader.load('./assets/images/3d/scene.gltf', function (gltf) {
            obj = gltf
            obj.scene.scale.set(.095, .09, .09)

            scene.add(obj.scene)
        })



        function animate() {
            requestAnimationFrame(animate)

            if (obj) {
                obj.scene.rotation.y += 0.01
            }

            renderer.render(scene, camera)
        }

        animate()
        return () => {
            window.removeEventListener('click', onWindowResize)
        }
    }, [])

    useEffect(() => {
        let i = 0;
        const txt = 'hello world!';
        const speed = 200;

        function typeWriter() {
            if (i < txt.length) {
                if(introTitle.current) introTitle.current.firstChild.innerHTML = txt.slice(0,i+1)
                i++;
                setTimeout(typeWriter, speed);
            }
        }

        typeWriter()
    }, [])

    return <>
        <section className="intro">
            <div className="container">
                <div className="intro_inner">
                    <div className="intro_content">
                        <h1 ref={introTitle}>
                            <span></span>
                            <span></span>
                        </h1>
                        <h3>Приветствую , меня зовут Роберт Атоян , я <span>Frontend</span> - разработчик , кроме обычной верстки
                            создаю SPA приложения с использованием <span>React</span>.</h3>
                        <h4 className={viewMode ? 'active' : ''}>
                            <p>P.S.
                                Если {viewMode && 'больше не'} хочешь {viewMode && <span>крутить</span>} {!viewMode && <span>покрутить Соника</span>},
                                жми на кнопку</p>
                            <button onClick={() => setViewMode(prev => !prev)} ref={btn}></button>
                        </h4>
                    </div>
                    <div className={"intro_model" + (viewMode ? ' active' : '')} ref={model}></div>
                </div>
            </div>
        </section>
    </>
})